<div id="gis-layers">
    <mat-card-header>
        <div class="search-section auto-margin">{{ 'CUSTOMER_EDITOR.AVAILABLE_SERVICES' | translate }}</div>
        <div class="app-flex-filler"></div>
    </mat-card-header>
    <mat-card-content>
        <app-loader [isLoading]="isLoading"></app-loader>
        <!-- GIS layer table -->
        <div id="gispagetable" *ngIf="gisDataSource?.length > 0">
            <mat-table #table [dataSource]="gisDataSource" matSort>
                <!-- GIS layer table column 1 -->
                <ng-container matColumnDef="type">
                    <mat-header-cell *matHeaderCellDef>{{ 'CUSTOMER_EDITOR.SERVICE_TYPE' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ mapTypeDisplayNames[element.serviceType] }}</mat-cell>
                </ng-container>
                <!-- GIS layer table column 2 -->
                <ng-container matColumnDef="url">
                    <mat-header-cell *matHeaderCellDef>{{ 'CUSTOMER_EDITOR.SERVICE_URL' | translate }}</mat-header-cell>
                    <mat-cell class="description-space" *matCellDef="let element">{{ element.url }} </mat-cell>
                </ng-container>
                <!-- GIS layer table edit icon -->
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef class="fixCellWidth"></mat-header-cell>
                    <mat-cell *matCellDef="let element" class="text-right">
                        <mat-icon matTooltip="{{ 'COMMON.EDIT_TOOLTIP' | translate }}" class="edit-cus-gis-edit-hint" (click)="editGISService(element)">mode_edit</mat-icon>
                        <mat-icon matTooltip="{{ 'COMMON.DELETE_BUTTON' | translate }}" (click)="deleteGISService(element.serviceId)">delete</mat-icon>
                    </mat-cell>
                </ng-container>
                <!-- GIS layer table delete icon -->

                <mat-header-row *matHeaderRowDef="gisDescriptionColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: gisDescriptionColumns"></mat-row>
            </mat-table>
        </div>
        <div class="notabledataFound custom-table" *ngIf="!isLoading && (!gisDataSource || gisDataSource.length === 0)">
            {{ 'ADMIN.NO_DATA_AVAILABLE' | translate }}
        </div>
    </mat-card-content>
</div>
